import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";

export default function StickyMobileCTA() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-mobile-cta"
      className={`md:hidden fixed bottom-0 left-0 right-0 z-30 p-4 transition-all duration-300 ${
        show ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
      }`}
    >
      <a
        href="#apply"
        className="w-full flex items-center justify-center gap-2 bg-gold hover:bg-gold-400 text-navy-950 font-semibold py-4 shadow-[0_10px_30px_rgba(0,0,0,0.5)]"
      >
        Get Approved Now <ArrowRight className="w-4 h-4" />
      </a>
    </div>
  );
}
